(() => {
  new Swiper(".js-brands-swiper", {
    slidesPerView: 3,
    spaceBetween: 16,
    preventInteractionOnTransition: true,
    autoplay: {
      delay: 0,
    },
    loop: true,
    freeMode: true,
    speed: 3500,
    breakpoints: {
      1024: {
        slidesPerView: 6,
        spaceBetween: 36,
      },
    },
  });
})();
